import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const submitFeedback = createAsyncThunk(
  "feedback/submitFeedback",
  async (feedbackData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post("/api/user/order/rate", feedbackData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to submit feedback.");
    }
  }
);

const rateOrderSlice = createSlice({
  name: "feedback",
  initialState: {
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitFeedback.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(submitFeedback.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(submitFeedback.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default rateOrderSlice.reducer;